<kendo-grid [data]="medAppointments$ | async" 
  [hideHeader]="true"
  [size]="'small'"
  kendoGridSelectBy="id" 
  [selectable]="selectableSettings" 
  [(selectedKeys)]="mySelection"
  (selectionChange)="selectionChange($event)"
  >
  <kendo-grid-column field="serviceProviderTitle" title="Лікар"> </kendo-grid-column>
  <kendo-grid-column field="specialtyTitle" title="Спеціалізація"> </kendo-grid-column>
  <kendo-grid-messages noRecords="На поточний час розклад прийомів ще визначається."> </kendo-grid-messages>
</kendo-grid>